export enum AppUserCompanyAccessType {
  None = 0,
  Details = 1,
  Collection = 2,
  Audit1 = 4,
  Audit2 = 8,
  Board = 16,
  Committees = 32,
  Ownership = 64,
  Family = 128,
  Salary1 = 256,
  Salary2 = 512,
  Accounting = 1024,
  Society = 2048,
  Employees = 4096,
  EnergyWater = 8192,
  EmissionsWaste = 16384,
  VotingResults = 32768,
  Messages = 65536,
  Process = 131072
}
